<script>
import { createWebHistory, createRouter } from 'vue-router';
import Home from '@/Pages/Home.vue';
import Paintings from '@/Pages/Paintings.vue';
import PaintingDetailView from '@/Pages/PaintingDetailView.vue';
import Courses from '@/Pages/Courses.vue';
import CourseDetailView from '@/Pages/CourseDetailView.vue';
import Exhibitions from '@/Pages/Exhibitions.vue';
import Login from '@/Pages/Login.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/paintings',
    name: 'paintings',
    component: Paintings,
  },
  {
    path: '/painting/:id',
    name: 'paintingDetailView',
    component: PaintingDetailView,
  },
  {
    path: '/courses',
    name: 'courses',
    component: Courses,
  },
  {
    path: '/course/:id',
    name: 'courseDetailView',
    component: CourseDetailView,
  },
  {
    path: '/exhibitions',
    name: 'Exhibitions',
    component: Exhibitions,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
</script>
